import { Button, Card, CircularProgress, Grid, InputLabel } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useCallback } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useHistory, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import { UploadImage, UploadPdf } from '../../../components';
import { getDetailLaporanTahunan, updLaporanTahunan } from '../../../redux/actions/LaporanTahunanActions';

const EditLaporanTahunan = () => {
    const { id } = useParams();
    const history = useHistory();
    const [submit, setSubmit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [params, setParams] = useState({
        year:"",
        cover:"",
        cover_preview: "",
        cover_ori: "",
        file:"",
        file_ori: '',
        rci_code: "",
    });
    const handleChange = ({ target: { value, name } }) => {
        setParams((pref) => ({
            ...pref,
            [name]: value
        }));
    };
    const handleFormSubmit = () => {
        setSubmit(true);
        updLaporanTahunan(params)
            .then(() => {
                showAlert('Data berhasil disimpan', true);
                setSubmit(false);
            })
            .catch((err) => {
                let error = err?.response?.data;
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal menyimpan data, coba beberapa saat lagi',
                    false
                );
                setSubmit(false);
            });
    };
    const showAlert = useCallback((text, success) => {
        Swal.fire({
            title: success ? 'Berhasil' : 'Oopss!',
            text: text,
            imageUrl: `/assets/images/icons/${
                success ? 'ic_success' : 'ic_error'
            }.svg`,
            imageWidth: 92,
            imageHeight: 92,
            confirmButtonText: 'Ok',
            confirmButtonColor: '#0083E2'
        }).then((res) => {
            if (res.isConfirmed && success) {
                history.goBack();
            }
        });
    }, [history]);
    const handleChangeFoto = (file, path) => {
        setParams((pref) => ({
            ...pref,
            cover: file,
            cover_preview: path
        }));
    };
    const getData = useCallback(() => {
        setLoading(true);
        getDetailLaporanTahunan(id)
            .then((res) => {
                let data = res.data?.data;
                if (Object.keys(data).length > 0) {
                    setParams((pref) => ({
                        ...pref,
                        year: data?.year,
                        cover: "",
                        cover_preview: data?.cover,
                        cover_ori: data?.cover_ori,
                        file: "",
                        file_ori: data?.file_ori,
                        rci_code: data?.rci_code,
                    }));
                } else {
                    showAlert(
                        'Gagal mengambil detail data laporan tahunan, coba beberapa saat lagi',
                        false
                    );
                }
                setLoading(false);
            })
            .catch((err) => {
                let error = err?.response?.data;
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal mengambil detail data laporan tahunan, coba beberapa saat lagi',
                    false
                );
                setLoading(false);
            });
    }, [id, showAlert]);
    useEffect(() => {
        setParams((pref) => ({
            ...pref,
            rci_code: id
        }));
        getData();
    }, [getData, id]);
    const handleChangeFile = (file, path) => {
        setParams(pref => ({
            ...pref,file
        }))
    }
    return (
        <div className="m-sm-30">
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={11} md={12}>
                    <h3 className="fw-bold m-0">Edit Laporan Tahunan</h3>
                </Grid>
                <Grid item xs={11} md={12}>
                    <Card elevation={0} className="py-5 px-6 border-radius-0 ">
                        {loading ? (
                            <div className="text-center">
                                <CircularProgress color="primary" size={35} />
                            </div>
                        ) : (
                            <ValidatorForm
                                onSubmit={handleFormSubmit}
                                className="w-full"
                            >
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <UploadImage
                                            uploadFoto={handleChangeFoto}
                                            label="Unggah Foto"
                                            preview={
                                                params?.cover_preview
                                            }
                                            required={true}
                                            aspectRatio={3/4}
                                            note={[
                                                'Format PNG, WEBP dan JPG diperbolehkan',
                                                '*Ukuran foto 488 x 650 atau 3:4'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <UploadPdf
                                            uploadFile={handleChangeFile}
                                            label="Unggah berkas"
                                            preview={
                                                params?.file
                                            }
                                            note={[
                                                'Format PDF diperbolehkan'
                                            ]}
                                            required={true}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <InputLabel htmlFor="year" className="mb-4">
                                            Tahun{' '}
                                            <span className="text-danger">*</span>
                                        </InputLabel>
                                        <TextValidator
                                            id="year"
                                            placeholder="Tahun"
                                            className="w-full"
                                            variant="outlined"
                                            onChange={handleChange}
                                            type="number"
                                            name="year"
                                            value={params.year || ''}
                                            validators={['required']}
                                            errorMessages={[
                                                'Masukkan Tahun terlebih dahulu'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid
                                            container
                                            spacing={2}
                                            justifyContent="flex-end"
                                            className="flex-column-reverse flex-md-row"
                                        >
                                            <Grid item xs={12} md={2}>
                                                <Button
                                                    color="primary"
                                                    className="text-primary w-full radius-6 text-capitalize py-2"
                                                    disableElevation
                                                    disabled={submit}
                                                    onClick={() =>
                                                        history.goBack()
                                                    }
                                                >
                                                    Batal
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    className="text-white w-full radius-6 text-capitalize py-2"
                                                    disableElevation
                                                    disabled={submit}
                                                >
                                                    {submit ? (
                                                        <CircularProgress
                                                            color="primary"
                                                            size={25}
                                                        />
                                                    ) : (
                                                        'Simpan'
                                                    )}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </ValidatorForm>
                        )}
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
};

export default EditLaporanTahunan;
